import { Search } from '@clearkit/icons';

import { LogsPage } from '~/components/api/LogsPage';
import { PageLayout } from '~/components/PageLayout';

export const PageAPILogs = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <Search />
      </PageLayout.Tile>
      <PageLayout.Heading>Logs</PageLayout.Heading>
      <PageLayout.SubHeading>
        Manage your API & Developer settings
      </PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body className="bg-white">
      <LogsPage />
    </PageLayout.Body>
  </PageLayout>
);
